module.exports = __webpack_public_path__ + "static/media/contact3.c6f905c3.png";